<template>
  <div>

    <!-- Welcome section for non-registered users (default) -->
    <b-row
      v-if="!isLoggedIn"
      class="mb-2 align-items-center"
    >
      <b-col
        cols="12"
        md="8"
      >
        <div class="ml-3">
          <h2 class="mb-0">
            Welcome to Structured Edge
          </h2>
          <p
            class="text-muted mb-1"
            style="max-width: 800px;"
          >
   Your comprehensive platform for structured product information and analysis. Access detailed market data, compare products across providers, and make informed investment decisions with our powerful analytics tools and regular updates.
          </p>
        </div>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <div class="d-flex">
          <b-card class="mb-0 flex-fill mr-1 text-center py-1">
            <div class="mb-1">
              <div
                class="font-weight-bold mb-50"
                style="font-size: 1rem;"
              >
                Existing Users
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                to="/login"
              >
                Log In
              </b-button>
            </div>
            <hr class="my-1">
            <div>
              <div
                class="font-weight-bold mb-50"
                style="font-size: 1rem;"
              >
                New Users
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                to="/register"
              >
                Register
              </b-button>
            </div>
          </b-card>
          <b-card class="welcome-explore-card mb-0 flex-fill ml-1 text-center py-1">
            <feather-icon
              icon="CompassIcon"
              size="20"
              class="flex-shrink-0"
            />
            <div
              class="welcome-explore-title font-weight-bold"
            >
              Explore service features
            </div>
            <!---<div
              class="text-muted mb-1 card-subtitle-wrap"
              style="font-size: 0.85rem;"
            >
              Explore platform features
            </div>--->
            <div class="d-flex flex-column w-100">
          <!---    <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                class="mb-50"
              >
                Start a Tour
              </b-button>--->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                size="sm"
                @click="scrollToBottom"
              >
                Find Out More
              </b-button>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-row>

    <div v-else>

      <!-- Welcome section for Premium users -->
      <b-row
        v-if="isPremium"
        class="mb-2 align-items-center"
      >
        <b-col
          cols="12"
          md="8"
        >
          <div class="ml-3">
            <h2 class="mb-0">
              Welcome back {{ usersFullName }}
            </h2>
            <p class="text-muted mb-1">
             Your comprehensive platform for structured product information and analysis. <br>You have full access to all premium content.

            </p>
          </div>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-row class="match-height">
            <b-col
              cols="6"
              class="mb-1"
            >
              <b-card class="mb-0 p-50 welcome-metric-card">
                <hint-popup
                  :id="1"
                  class="welcome-metric-hint"
                />
                <loading-container
                  v-if="premiumMetricsLoading"
                  :padding-y="0"
                  class="welcome-metric-loader"
                />
                <div
                  class="d-flex align-items-center welcome-metric-content"
                  :class="{ invisible: premiumMetricsLoading }"
                >
                  <b-avatar
                    variant="light-primary"
                    size="32"
                    class="mr-1"
                  >
                    <feather-icon
                      icon="LogInIcon"
                      size="16"
                    />
                  </b-avatar>
                  <div>
                    <div style="font-size: 1.1rem; font-weight: 700;">
                      {{ formatMetric(currentProductsViewed) }}/{{ formatMetric(totalCurrentProducts) }}
                    </div>
                    <div style="font-size: 0.85rem;">
                      Current products viewed
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
            <b-col
              cols="6"
              class="mb-1"
            >
              <b-card class="mb-0 p-50 welcome-metric-card">
                <hint-popup
                  :id="2"
                  class="welcome-metric-hint"
                />
                <loading-container
                  v-if="premiumMetricsLoading"
                  :padding-y="0"
                  class="welcome-metric-loader"
                />
                <div
                  class="d-flex align-items-center welcome-metric-content"
                  :class="{ invisible: premiumMetricsLoading }"
                >
                  <b-avatar
                    variant="light-success"
                    size="32"
                    class="mr-1"
                  >
                    <feather-icon
                      icon="ClipboardIcon"
                      size="16"
                    />
                  </b-avatar>
                  <div>
                    <div style="font-size: 1.1rem; font-weight: 700;">
                      {{ formatMetric(currentProductDocumentsDownloaded) }}
                    </div>
                    <div style="font-size: 0.85rem;">
                      Current product documents downloaded
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
            <b-col cols="6">
              <b-card class="mb-0 p-50 welcome-metric-card">
                <hint-popup
                  :id="3"
                  class="welcome-metric-hint"
                />
                <loading-container
                  v-if="premiumMetricsLoading"
                  :padding-y="0"
                  class="welcome-metric-loader"
                />
                <div
                  class="d-flex align-items-center welcome-metric-content"
                  :class="{ invisible: premiumMetricsLoading }"
                >
                  <b-avatar
                    variant="light-info"
                    size="32"
                    class="mr-1"
                  >
                    <feather-icon
                      icon="ActivityIcon"
                      size="16"
                    />
                  </b-avatar>
                  <div>
                    <div style="font-size: 1.1rem; font-weight: 700;">
                      {{ formatMetric(clientSelectionRecords) }}
                    </div>
                    <div style="font-size: 0.85rem;">
                      Client selection records created in last 90 days
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
            <b-col cols="6">
              <b-card class="mb-0 p-50 welcome-metric-card">
                <hint-popup
                  :id="4"
                  class="welcome-metric-hint"
                />
                <loading-container
                  v-if="premiumMetricsLoading"
                  :padding-y="0"
                  class="welcome-metric-loader"
                />
                <div
                  class="d-flex align-items-center welcome-metric-content"
                  :class="{ invisible: premiumMetricsLoading }"
                >
                  <b-avatar
                    variant="light-warning"
                    size="32"
                    class="mr-1"
                  >
                    <feather-icon
                      icon="TrendingUpIcon"
                      size="16"
                    />
                  </b-avatar>
                  <div>
                    <div style="font-size: 1.1rem; font-weight: 700;">
                      {{ formatMetric(portfolioReportsDownloaded) }}
                    </div>
                    <div style="font-size: 0.85rem;">
                      Portfolio reports downloaded in last 90 days
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Welcome section for Basic users -->
      <b-row
        v-else
        class="mb-2 align-items-center"
      >
        <b-col
          cols="12"
          md="8"
        >
          <div class="ml-3">
            <h2 class="mb-0">
              Welcome back {{ usersFullName }}
            </h2>
            <p class="text-muted mb-1">
               Your comprehensive platform for structured product information and analysis. <br>You have access to standard content.
            </p>
          </div>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <UpgradeToPremium />
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BAvatar,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import UpgradeToPremium from '@/views/components/UpgradeToPremium.vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import HintPopup from '@/views/components/HintPopup.vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'WelcomeSection',
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BAvatar,
    UpgradeToPremium,
    LoadingContainer,
    HintPopup,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      currentProductsViewed: null,
      totalCurrentProducts: null,
      currentProductDocumentsDownloaded: null,
      clientSelectionRecords: null,
      portfolioReportsDownloaded: null,
      premiumMetricsLoading: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
      'isPremium',
      'usersFullName',
    ]),
  },
  watch: {
    isPremium: {
      immediate: true,
      handler() {
        this.loadPremiumMetrics()
      },
    },
  },
  activated() {
    this.loadPremiumMetrics()
  },
  methods: {
    loadPremiumMetrics() {
      if (!this.isPremium || this.premiumMetricsLoading) return

      this.premiumMetricsLoading = true

      Promise.all([
        this.loadTotalCurrentProducts(),
        this.loadHitCount('product_view_current'),
        this.loadHitCount('product_download_current'),
        this.loadHitCount('selection_record_generate', 90),
        this.loadHitCount('portfolio_download_pdf', 90),
        this.loadHitCount('portfolio_download_csv', 90),
      ])
        .then(([totalCurrentProducts, currentProductsViewed, currentProductDocumentsDownloaded, clientSelectionRecords, portfolioPdfDownloads, portfolioCsvDownloads]) => {
          this.totalCurrentProducts = totalCurrentProducts
          this.currentProductsViewed = currentProductsViewed
          this.currentProductDocumentsDownloaded = currentProductDocumentsDownloaded
          this.clientSelectionRecords = clientSelectionRecords
          this.portfolioReportsDownloaded = portfolioPdfDownloads + portfolioCsvDownloads
        })
        .catch(error => {
          console.error('Error loading premium welcome metrics:', error)
        })
        .then(() => {
          this.premiumMetricsLoading = false
        })
    },
    loadTotalCurrentProducts() {
      return this.$http
        .get('public.cfc?method=getProductCount')
        .then(response => this.getCount(response.data.TOTAL))
    },
    loadHitCount(hitname, days = -1) {
      const params = {
        method: 'getHitCountByHitname',
        hitname,
      }

      if (days !== -1) params.days = days

      return this.$http
        .get('hits.cfc', { params })
        .then(response => this.getCount(response.data))
    },
    getCount(value) {
      const count = value?.COUNT ?? value?.count ?? value?.TOTAL ?? value?.total ?? value
      return Number(count) || 0
    },
    formatMetric(value) {
      return value === null || value === undefined ? '--' : value
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.welcome-explore-card ::v-deep .card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.25rem;
}

.welcome-explore-title {
  font-size: 1rem;
  line-height: 1.45;
  margin: -0.5rem 0 0;
}

.card-subtitle-wrap {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
}

.welcome-metric-card ::v-deep .card-body {
  min-height: 74px;
  display: flex;
  align-items: center;
  position: relative;
}

.welcome-metric-loader {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.welcome-metric-hint {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
}

.welcome-metric-hint ::v-deep .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
}

.welcome-metric-content {
  width: 100%;
}

.find-out-more-link {
  text-decoration: underline;
  color: #1a73e8;
  font-size: 1rem;
  transition: opacity 0.2s;
}

.find-out-more-link:hover {
  opacity: 0.8;
  text-decoration: underline;
  color: #1a73e8;
}
</style>
